/* eslint-disable react-hooks/exhaustive-deps */
import { React, useState, useRef } from 'react'
import { Flex, Image, Text, Box, HStack, Input } from '@chakra-ui/react'
import SVGIcon from '../../assets/svgIcons'

import styles from './idCard.module.css'
import { pushFileToS3, loadAwsFile } from '../../utils/aws.util'
export default function IdCard(props) {
	const {
		name,
		org,
		account,
		asset_type_name,
		defaultProfilePic,
		orgLogo,
		orgColor,
		isEditCheck,
		editProfileDetails,
		setEditprofileDetails,
		profileImageData,
		nameErrorMessage,
		setattachmentURl,
		attachmentURl,
	} = props

	const handleChange = e => {
		const { name, value } = e.target
		setEditprofileDetails({ ...editProfileDetails, [name]: value })
	}
	const inputRef = useRef()
	const inputRefImg = useRef()
	let img = !!profileImageData ? profileImageData : defaultProfilePic

	const onHandleFileChange = async event => {
		const file = event.target['files'][0]
		const blob = file?.slice(0, file.size, file?.type)
		const newFile = new File([blob], file?.name.replace(/ /gi, '-'), {
			type: blob.type,
		})
		let result = await pushFileToS3(newFile)
		const [{ url }] = await Promise.all([result])

		if (url) {
			setEditprofileDetails({
				...editProfileDetails,
				employee_profile_picture: url,
			})
			loadAwsFile(url, d => {
				let data = 'data:' + d.type + ';base64,' + d.data
				setattachmentURl(data)
			})
		}
	}
	img = !!attachmentURl ? attachmentURl : img

	return (
		<Box
			bg='white'
			boxShadow='2px 2px 5px 5px rgba(14, 31, 53, 0.5)'
			borderRadius='15px'
			w='305px'
			minH='450px'
			color='black'
			mx='auto'
		>
			<Flex
				flex={1}
				h='full'
				alignItems='center'
				justifyContent='center'
				flexDir='column'
			>
				<Box
					bg='linear-gradient(225deg, #009B76 0%, #016F54 100%)'
					borderRadius='6px'
					w='100px'
					h='10px'
					mt='16px'
				></Box>

				<Box
					bg={orgColor}
					w='305px'
					minH='44px'
					mt='26px'
					display='flex'
					alignItems='center'
					justifyContent='center'
				>
					<Box minH='32px'>
						<HStack spacing='8px'>
							<Box w='32px' minH='32px'>
								{orgLogo !== 'defaultOrgIcon' ? (
									<Image
										src={orgLogo}
										w='36px'
										h='32px'
										filter='brightness(0) invert(1)'
									/>
								) : (
									<SVGIcon
										iconName='IdCardGreneLogoSvg'
										svgProps={{
											width: '32',
											height: '32',
											viewBox: '0 0 32 32',
										}}
									/>
								)}
							</Box>

							<Box
								maxW='237px'
								minH='22px'
								fontStyle='normal'
								fontWeight='800'
								fontSize='15px'
								lineHeight='22px'
								letterSpacing='0.2px'
								color='#FFFFFF'
							>
								{org}
							</Box>
						</HStack>
					</Box>
				</Box>

				{!isEditCheck ? (
					<>
						<Box
							mt='24px'
							width='205px'
							height='216.4px'
							background='#ffffff'
							borderRadius='10px'
						>
							<Image
								src={img}
								borderRadius='10px'
								alt='profile pic'
								width='205px'
								height='216.4px'
							/>
						</Box>
						<Box
							w='200px'
							mt='7px'
							fontStyle='normal'
							fontWeight='900'
							fontSize='20px'
							lineHeight='27px'
						>
							<Text color={orgColor} textAlign='center'>
								{name}
							</Text>
						</Box>

						<Box
							minW='150px'
							maxW='250px'
							minH='20px'
							mt='3px'
							text-align='center'
							fontStyle='normal'
							fontWeight='500'
							fontSize='15px'
							lineHeight='22px'
						>
							<Text color='#000000' textAlign='center'>
								{asset_type_name}
							</Text>
						</Box>

						<Box
							minW='150px'
							maxW='250px'
							minHeight='19px'
							mt='2px'
							mb='5px'
							text-align='center'
							fontStyle='normal'
							fontWeight='500'
							fontSize='14px'
							lineHeight='19px'
						>
							<Text color='#000000' textAlign='center'>
								{!!account ? `(${account})` : ''}
							</Text>
						</Box>
					</>
				) : (
					<>
						{profileImageData ? (
							<Box
								mt='24px'
								width='205px'
								height='216.4px'
								background='#ffffff'
								borderRadius='10px'
								position='relative'
							>
								<Image
									src={img}
									borderRadius='10px'
									alt='profile pic'
									width='205px'
									height='216.4px'
								/>
								<Box
									bg='brand.700'
									width={30}
									height={30}
									borderRadius='50%'
									bottom='8px'
									right='16px'
									position='absolute'
									cursor='pointer'
									onClick={() => {
										inputRefImg.current.click()
									}}
								>
									<SVGIcon
										iconName='WhiteCameraSvg'
										svgProps={{
											width: '36',
											height: '36',
											viewBox: '-7 -5 36 36',
										}}
									/>
									<input
										type='file'
										accept='image/*'
										name='file'
										onChange={onHandleFileChange}
										ref={inputRefImg}
										style={{ display: 'none' }}
									></input>
								</Box>
							</Box>
						) : (
							<Box
								mt='24px'
								width='205px'
								height='216.4px'
								background='#E3E3E3'
								position='relative'
							>
								{attachmentURl && !profileImageData && (
									<Image
										src={img}
										borderRadius='10px'
										width='205px'
										height='216.4px'
										alt='profile pic'
									/>
								)}
							
								<Box
									width={30}
									height={30}
									bottom='45%'
									right='45%'
									position='absolute'
									cursor='pointer'
									onClick={() => {
										inputRef.current.click()
									}}
								>
									<SVGIcon
										iconName='CameraSvg'
										svgProps={{
											width: '36',
											height: '36',
											viewBox: '0 0 36 36',
										}}
									/>
									<input
										type='file'
										accept='image/*'
										name='file'
										onChange={onHandleFileChange}
										ref={inputRef}
										style={{ display: 'none' }}
									></input>
								</Box>
							</Box>
						)}

						<Box
							borderBottom={
								!!nameErrorMessage
									? '1px solid red'
									: '1px solid rgba(0, 0, 0, 0.25)'
							}
							className={styles.inputIDCard}
							width={'80%'}
						>
							<Input
								p={0}
								border='none'
								_placeholder={{ color: '#828282' }}
								placeholder='Add Full Name'
								value={editProfileDetails.employee_first_name}
								name='employee_first_name'
								onChange={e => handleChange(e)}
							/>
						</Box>
					</>
				)}
				{!!nameErrorMessage ? (
					<Text color={'red'} mt='5px'>
						{nameErrorMessage}
					</Text>
				) : (
					''
				)}
			</Flex>
		</Box>
	)
}
